import { render } from "./mingyi.vue?vue&type=template&id=70acfa5d&scoped=true"
import script from "./mingyi.vue?vue&type=script&lang=js"
export * from "./mingyi.vue?vue&type=script&lang=js"

import "./mingyi.vue?vue&type=style&index=0&id=70acfa5d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70acfa5d"]])

export default __exports__